const topics = [
  { label: '动作大片', hot: true, count: '1.2万' },
  { label: '悬疑烧脑', hot: true, count: '9800' },
  { label: '喜剧合家欢', hot: false, count: '8600' },
  { label: '科幻巨制', hot: true, count: '1.1万' },
  { label: '国剧精品', hot: true, count: '2.3万' },
  { label: '韩剧热播', hot: false, count: '1.5万' },
  { label: '日漫连载', hot: true, count: '1.8万' },
  { label: '综艺热榜', hot: false, count: '7200' },
  { label: '纪录片', hot: false, count: '5400' },
  { label: '经典怀旧', hot: true, count: '9600' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center">
          热门话题
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">大家都在看这些类型</p>

        <div className="mt-8 flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.label}
              className="group flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-full border border-background-200 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer"
            >
              {topic.hot && (
                <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse shrink-0"></span>
              )}
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                {topic.label}
              </span>
              <span className="text-xs text-foreground-400">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}